<template>
  <div class="container">
    <div class="onsite mb-5">
      <h3>ON-SITE TRAINING</h3>
    </div>
    <div class="row">
      <div class="col-lg-6 mb-3">
        <div class="read">
          <p>At Fhenix Africa, we are dedicated to empowering individuals with the skills, resources, and opportunities they need to thrive in the digital world. One of our key offerings is our on-site training services, designed to provide hands-on learning experiences that drive tangible results.</p>
<p>Our on-site training programs are tailored to meet the unique needs of individuals. Whether you are looking to get upskilled in digital marketing, web development, UI/UX design, or other digital skills, we have the expertise to deliver comprehensive training that enhances your capabilities.</p>
<p>Our approach to on-site training is practical and results-oriented. We believe in a hands-on approach that allows participants to apply what they learn in real-world scenarios, enabling them to immediately implement their newfound skills in their day-to-day work.
Our team of experienced trainers are industry experts who are passionate about sharing their knowledge and expertise. They use a variety of teaching methods, including interactive workshops, case studies, and practical exercises, to ensure participants are engaged and actively learning.</p>
<p>Join us at Fhenix Africa and get empowered with the digital skills you need to excel in today's fast-paced business landscape. Contact us to discuss how our customized on-site training programs can help you thrive in the digital world.
</p>
        </div>
        <div class="get-us">
          <a href="#contact">Contact us</a>
        </div>
      </div>
      <div class="col-lg-6 mb-3">
        <div class="oncheck">
          <img src="../assets/Images/newonsite.png" alt="" class="img-fluid" />
        </div>
      </div>
    </div>
    <div class="available mt-5">
      <div class="tracks">
        <h6>Available Tracks</h6>
        <p>
          Here are some of the tracks we have
        </p>
      </div>
      <div class="row my-5">
        <div
          class="col-lg-4 col-md-6 skip mb-3"
          v-for="track in tracks"
          :key="track"
          role="button"
          @click="showCourse(track)"
        >
          <div class="developers p-3 h-100">
            <small>{{ track.name }}</small>
            <p class="mb-3 mt-2">{{ track.paragraph }}</p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="Object.keys(clickedTrack).length > 0">
      <track-detail-card :selectedTrack="clickedTrack" />
    </div>

    <div class="row">
      <div
        class="col-lg-4 col-md-6"
        v-for="experience in experiences"
        :key="experience"
      >
        <div class="experience p-3">
          <small>{{ experience.name }}</small>
          <p class="mb-5 mt-2">{{ experience.paragraph }}</p>
        </div>
      </div>
    </div>
    <div class="views">
      <p>Images from our Inhouse training sessions</p>
      <div class="row gaping">
        <div class="col-lg-3 col-md-6 mb-3">
          <div class="img-1">
            <img src="../assets/Images/house1.png" alt="" class="img-fluid" />
          </div>
        </div>
        <div class="col-lg-3 col-md-6 mb-3">
          <div>
            <div class="img-2">
              <img
                src="../assets/Images/standingman.png"
                alt=""
                class="img-fluid"
              />
            </div>
            <div class="img-3">
              <img
                src="../assets/Images/techbros.png"
                alt=""
                class="img-fluid"
              />
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 mb-3">
          <div class="img-4">
            <img
              src="../assets/Images/beautifullady.png"
              alt=""
              class="img-fluid"
            />
          </div>
        </div>
        <div class="col-lg-3 col-md-6 mb-3">
          <div>
            <div class="img-5">
              <img
                src="../assets/Images/fingers.png"
                alt=""
                class="img-fluid"
              />
            </div>
            <div class="img-6">
              <img
                src="../assets/Images/fairlady.png"
                alt=""
                class="img-fluid"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import More from "@/components/More.vue";
import TrackDetailCard from "./training/TrackDetailCard.vue";
let id = 0;
export default {
  data() {
    return {
      tracks: [
        {
          id: id++,
          name: "Android Development",
          paragraph:
            "Our Android development training covers a wide range of topics, including Java and Kotlin programming languages, UI/UX design, app architecture, database integration, networking, and more. Learners will also learn how to test, debug, and optimize their apps to ensure they meet industry standards and deliver a seamless user experience.",
        },
        {
          id: id++,
          name: "Frontend Web Development",
          paragraph:
            "Our expert instructors bring their extensive industry experience to provide comprehensive training in frontend web development, covering topics such as HTML, CSS, JavaScript, responsive design, and user experience (UX) design. Learners will gain hands-on experience through practical exercises, projects, and real-world examples, allowing them to apply their skills in building functional and visually appealing websites.",
        },
        {
          id: id++,
          name: "Backend Web Development",
          paragraph:
            "From building APIs and working with databases to server-side scripting and performance optimization, our Backend development training program equips learners with the skills needed to develop robust and scalable web applications.",
        }, 
        {
          id: id++,
          name: "User Experience & Interface Design",
          paragraph:
            "Our UI/UX design course provides comprehensive training that covers the latest tools, techniques, and best practices in product design. Learners will gain a deep understanding of user-centered design principles, information architecture, wireframing, prototyping, usability testing, and more.",
        },
        {
          id: id++,
          name: "Digital Marketing",
          paragraph:
            "From understanding the fundamentals of digital marketing to mastering advanced concepts such as SEO, social media marketing, content marketing, email marketing, and more, our training program covers a wide range of topics to ensure learners are well-rounded in their digital marketing skills.",
        },
        {
          id: id++,
          name: "Data Science",
          paragraph:
            "Learners in our Data science program will gain proficiency in various aspects of data science, including data exploration, data visualization, statistical analysis, machine learning algorithms, and model deployment.",
        },
        {
          id: id++,
          name: "Computer Aided Design (CAD)",
          paragraph:
            "Our CAD training program covers CAD software such as AutoCAD, SolidWorks, Revit, and more. Learners will gain hands-on experience through practical exercises, projects, and real-world examples, allowing them to develop their CAD skills and apply them in real-time scenarios.",
        },
        {
          id: id++,
          name: "Programming Foundation",
          paragraph:
            "Led by our expert instructors, this training covers key programming languages and frameworks, such as Python, JavaScript, HTML, CSS, and more. Learners will gain hands-on experience through practical exercises and coding projects.",
        },
        {
          id: id++,
          name: "Embedded Systems",
          paragraph:
            "Our expert instructors bring their extensive industry experience to deliver comprehensive training that covers a wide range of embedded systems concepts, including microcontrollers, firmware development, real-time operating systems, device drivers, and more.",
        },
      ],
      clickedTrack: {},
    };

   
    
  },
  components: {
    More,
    TrackDetailCard,
  },
  methods: {
    showCourse(course) {
      this.clickedTrack = course;
    },
  },
};
</script>

<style scoped>
.img-1 img,
.img-4 img {
  border-radius: 12px;
}
.img-2 img,
.img-3 img {
  border-radius: 12px;
}
.img-5 img,
.img-6 img {
  width: 100%;
  height: 195px;
  object-fit: cover;
  border-radius: 12px;
}
.img-6,
.img-3 {
  margin-top: 1rem;
}
img:hover {
  opacity: 0.8;
}
.onsite h3 {
  font-style: normal;
  font-weight: 600;
  font-size: 40px;
  line-height: 48px;
  color: #ff6600;
}
.tracks h6 {
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 150%;
  color: #000000;
}
.personal h3 {
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 150%;
  color: #ff6600;
}
.experience small {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  color: #ff6600;
}
.our-service h3 {
  font-style: normal;
  font-weight: 600;
  font-size: 40px;
  line-height: 48px;
  color: #1f1f1f;
  margin-bottom: 3rem;
}
/* for p tags */
.read p {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  color: #595959;
}
.tracks p {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: #595959;
}
.developers small {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: #ff6600;
  text-align: center;
}

.reacher a {
  background: #ff6600;
  border-radius: 8px;
  text-decoration: none;
  padding: 11px 48px;
  color: #ffffff;
  transition: 1s ease-in-out;
}

.reacher a:hover,
.reacher a:focus {
  background: transparent;
  color: #ff6600;
  border: 3px solid #ff6600;
  transition: 1s ease-in-out;
}

.developers p {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  color: #595959;
}

.personal p {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 184%;
  color: #595959;
  margin-right: 112px;
}
.views p {
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 150%;
  color: #595959;
  margin-bottom: 3rem;
}

.here p {
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  color: #4d4d4d;
  margin-top: 17px;
}

.tools {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  color: #335ca6;
}
.best {
  font-size: 14px;
  margin-top: 2.1rem;
}
/* for colors */
.train {
  color: #ffffff;
}

.developers {
  background: #ffffff;
  border-radius: 12px;
  border: 2px solid transparent;
  transition: all 0.5s ease-out;
}

.ram {
  margin-bottom: 1.5rem;
}

.android-develop {
  background: #ffffff;
  margin-bottom: 2.7rem;
}

.developers:hover,
.developers:focus {
  border: 2px solid #ff6600;
  background: rgba(136, 203, 84, 0.1);
}
.experience {
  background: #ffffff;
  border-radius: 12px;
  border: 2px solid transparent;
  transition: all 0.5s ease-out;
}

.experience:hover,
.experience:focus {
  border: 2px solid #ff6600;
  background: rgba(136, 203, 84, 0.1);
}
.more-services {
  background: #ffffff;
  width: 100%;
  padding: 3.5rem 0;
}
/* for a tags */
.reacher {
  margin-top: 2.5rem;
}

.get-us a {
  text-decoration: none;
  padding: 8px 45px;
  border: 3px solid #ff6600;
  border-radius: 8px;
  color: #ff6600;
  transition: 1s ease-in-out;
}
.get-us a:hover,
.get-us:focus {
  background: #ff6600;
  color: #fff;
}
/* for margins */
.available {
  margin-top: 5rem;
}
.reversing {
  padding: 4rem 0;
}

.read {
  margin-top: 1.4rem;
}
.experience {
  margin-bottom: 2rem;
}
.views {
  margin-bottom: 2.5rem;
}
.get-us {
  margin-top: 3rem;
}

.key {
  margin-top: 2rem;
}

.android-develop {
  padding: 3.5rem 1rem;
}

/* for responsiveness */
@media screen and (max-width: 768px) {
  .training {
    /* width: 100%; */
    height: 360px;
  }
  /* for h tags */
  .train h1 {
    font-size: 46px;
  }

  /* for tags */
  .train p {
    padding: 0 202px;
  }
  .read p {
    margin-right: 0px;
    font-size: 16px;
  }

  .get-us {
    position: relative;
    /* top: 619px; */
    display: flex;
    justify-content: center;
  }
  .onsite h3 {
    text-align: center;
    margin-bottom: -40px;
  }
  .oncheck img {
    margin-right: auto;
    margin-left: auto;
    display: block;
  }
  
  .skip,
  .experience {
    margin-bottom: 1.8rem;
  }
  .developers:hover {
    border: none;
    background: none;
  }
  .experience:hover {
    border: none;
    background: none;
  }

  .img-5,
  .img-4 {
    margin-top: 1.5rem;
  }
  .img-2 img,
  .img-3 img,
  .img-5 img,
  .img-6 img {
    width: 333px;
  }

  .personal {
    text-align: center;
  }

  .personal p {
    margin: 0px 0px;
  }
  .here {
    margin: 0px 66px;
  }
  .key img {
    margin-left: auto;
    margin-right: auto;
    display: block;
  }

  ul {
    list-style: none;
  }
  .best {
    text-align: center;
  }
  .reacher {
    display: flex;
    justify-content: center;
  }
  .android-develop {
    background-color: transparent;
  }
}

@media screen and (max-width: 425px) {
  .my-program {
    width: 631px;
    background: rgb(8, 2, 2);
  }
  .train p {
    padding: 0px 108px;
  }

  .training {
    width: 631px;
  }

  .experience {
    margin-bottom: 1.8rem;
  }
  .experience p {
    padding: 0 34px;
    font-size: 23px;
  }
  .developers p {
    font-size: 16px;
  }

  .developers small {
    text-align: center;
    font-size: 22px;
  }

  .experience small {
    font-size: 26px;
  }

  .experience,
  .developers {
    background: none;
  }
  .img-1 img,
  .img-4 img,
  .img-2 img,
  .img-3 img,
  .img-5 img,
  .img-6 img {
    margin-left: auto;
    margin-right: auto;
    display: block;
  }
  .img-6,
  .img-3,
  .img-2,
  .img-4,
  .img-5 {
    margin-top: 37px;
  }

  .views {
    text-align: center;
  }

  .tracks {
    text-align: center;
  }

}

@media screen and (max-width: 375px) {
}
@media screen and (max-width: 320x) {
}
</style>